import React from 'react';
import styled from 'styled-components';

import BigTriangle from '../../components/BigTriangle';
import Footer from '../../components/Footer';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentCenterer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  @media (max-width: 800px) {
    margin-top: 20px;
  }
  flex: 1;
  z-index: 2;
`;

const Content = styled.div``;

const TrianglePosition = styled.div`
  position: absolute;
  left: -121px;
  top: calc(50% - 244px);
  z-index: -1;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const FooterHolder = styled.div`
  margin-top: 100px;
  width: 100%;
`;

type Props = {
  children?: React.ReactNode;
};

function Wrapper({ children }: Props) {
  return (
    <Page>
      {/* <LogoPosition onClick={() => router.push(routes.home)}>
        <Logo />
      </LogoPosition> */}
      <TrianglePosition>
        <BigTriangle />
      </TrianglePosition>

      <ContentCenterer>
        <Content>{children}</Content>
      </ContentCenterer>
      <FooterHolder>
        <Footer />
      </FooterHolder>
    </Page>
  );
}

export default Wrapper;
